<template >
  <div class="container">
    <div class="row justify-content-center">
       <div class="card mycard" style="width:50%">
        <div class="card-body p-0">
          <div class="p-5">
            <div class="row text-center">
              <div class="col col-expand">
                <h1 class="h4 text-gray-900 mb-4">Хичээл нэмэх </h1>
              </div>
            </div>
            <form class="user">
              <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="exampleFormControlSelect1" class="font-weight-bold">Хичээл:</label>
                          <select class="form-control" v-model="lesson.category">
                              <option
                              v-for="(type, index) in categories"
                              v-bind:key="'type-' + type.id"
                              v-bind:value="type.ref"
                              >
                              {{ index + 1 }}. {{ type.name }}
                              <span v-if="type.typeDetail"
                                  >- {{ type.typeDetail.name }}</span
                              >
                              </option>
                          </select>
                  </div>
                  <!-- <div class="form-group col-md-12" v-if="departments && departments.length > 0">
                  <label for="exampleFormControlSelect1"  class="font-weight-bold">Анги:</label>
                    <select class="form-control" v-model="department">
                      <option
                        v-for="(dep) in departments"
                        v-bind:key="dep.id"
                        v-bind:value="dep"
                      >
                        {{ dep.name }} - {{dep.startYear}}
                      </option>
                    </select>
                  </div> -->
              
              </div>
              <div class="form-group">
                <label for="exampleFormControlSelect1" class="font-weight-bold">Aнги/группээр орох:</label>
                <div class="form-check">
                  <input
                    v-model="lesson.isGroup"
                    class="form-check-input"
                    type="radio"
                    name="exampleRadios"
                    id="exampleRadios1"
                    v-bind:value="false"
                  />
                  <label class="form-check-label" for="exampleRadios1">
                    Ангиар ороx
                  </label>
                </div>
                <div class="form-check">
                  <input
                    v-model="lesson.isGroup"
                    class="form-check-input"
                    type="radio"
                    name="exampleRadios"
                    id="exampleRadios2"
                    v-bind:value="true"
                  />
                  <label class="form-check-label" for="exampleRadios2">
                    Группээр ороx <span class="font-weight-bold">(Жиш: Теxнологийн xичээл)</span>
                  </label>
                </div>
              </div>
            </form>

            <hr />
            <div class="row">
              <div class="text-center col">
                <a class="text-primary" style="cursor:pointer" @click="$router.back()">Буцах</a>
              </div>
              <div class="col">
                <div @click="save" class="btn btn-primary">Хадгалах</div>
              </div>
            </div>
            <hr />
          </div>
        </div>
      </div>
    </div>
    
    <div
      v-if="loading == true"
      style="position: fixed; z-index: 10000000; top: 45%; left: 45%"
    >
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import { copyFile } from "fs";
export default {
  name: "XAddLesson",
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  data() {
    return {
      teacherDoc:null,
      lesson: {
        name: "",
        description: "",
        requirements: [],
        results: [],
        whatlearned: [],
        teacherFirstName: "",
        teacherLastName: "",
        // skills:[],
        handlaga: [],
        semester: null,
        credit: null,
        type: null,
        category: null,
        isGroup: null,
        sector: null,
      },
      performingRequest: false,
      requirement: "",
      result: "",
      schools: [],
      school: null,
      department: null,
      programs: [],
      program: null,
      semesters: [],
      semester: null,
      departments: [],
      categories: [],
      selectedTeacher: null,
      sectors: [],
      selectedPrograms: [],
      selectedGroups: [],
      groupList: [],
      loading: false,
      lessonGroups: [],
    };
  },
  watch: {
    department: function (val) {
      if (val && val.ref) {
        this.programs = [];
        this.selectedPrograms = [];
        this._getPros(val);
      }
    },
    "lesson.isGroup": function (val) {
      this.groupList = [];
    },
    "lesson.category": function (val) {
      if (val && val.id) {
        val.get().then((doc) => {
          if (doc && doc.exists && doc.data() && doc.data().name) {
            this.lesson.name = doc.data().name;
          }
        });
      }
    },
    "lesson.sector": function (val) {
      this.teachers = [];
      if (val && val.id) {
        fb.db
          .collection("schools/" + this.schoolId + "/teachers")
          .where("sector", "==", val)
          .orderBy("name")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((paymentData) => {
              let object = paymentData.data();
              object.ref = paymentData.ref;
              object.id = paymentData.id;
              this.teachers.push(object);
            });
          });
      } else {
        fb.db
          .collection("schools/" + this.schoolId + "/teachers")
          .orderBy("name")
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((paymentData) => {
              let object = paymentData.data();
              object.ref = paymentData.ref;
              object.id = paymentData.id;
              this.teachers.push(object);
            });
          });
      }
    },
    selectedTeacher: function (val) {
      if (val && val.id && val.ref) {
        this.lessonGroups = [];
        fb.db
          .collection("schools/" + this.schoolId + "/lessonGroups")
          .where("teacher", "==", val.ref)
          .get()
          .then((querySnapshot) => {
            let deps = [];
            querySnapshot.forEach((depdata) => {
              deps.push(depdata);
            });
            this.lessonGroups = deps;
          });
      } else {
        fb.db
          .collection("schools/" + this.schoolId + "/lessonGroups")
          .orderBy("createdAt")
          .get()
          .then((querySnapshot) => {
            let deps = [];
            querySnapshot.forEach((depdata) => {
              deps.push(depdata);
            });
            this.lessonGroups = deps;
          });
      }
    },
  },
  methods: {
 
    async save() {
      this.performingRequest = true;
      if (this.lesson.category) {
        this.loading = true;
        this.lesson.name = this.capitalizeFirstLetter(this.lesson.name);
        this.lesson.userId = this.$store.getters.currentUser.uid;
        this.lesson.user = fb.usersCollection.doc(this.$store.getters.currentUser.uid);
        this.lesson.createdAt = new Date();
        this.lesson.checkedAt = new Date();
        this.lesson.lectureCode = new Date().getTime();
        this.lesson.school = this.school;
        this.lesson.year = this.school.currentYear
        
        // var teacherDoc=await group.teacher.ref.get();
        this.lesson.teacher = this.teacherDoc.ref;
        this.lesson.teachers=[];
        this.lesson.teacherRefs=[];
        this.lesson.teacherRefs.push(this.teacherDoc.ref);

        var firstName = this.teacherDoc.data().firstName!=undefined && this.teacherDoc.data().firstName!=null?this.teacherDoc.data().firstName:this.teacherDoc.data().name;
        if(firstName==undefined)
          firstName=null
        var lastName = this.teacherDoc.data().lastName!=undefined && this.teacherDoc.data().lastName!=null?this.teacherDoc.data().firstName:this.teacherDoc.data().lastname;
        
        if(lastName)
          lastName = null

        this.lesson.teachers.push({
            "firstName": firstName,
            "lastName": lastName,
            "description": this.teacherDoc.data().description!=undefined && this.teacherDoc.data().description!=null?this.teacherDoc.data().description:'Багш',
            "reference": this.teacherDoc.ref
        });

        console.log(this.lesson)

        fb.db.collection("schools/"+this.schoolId+"/lessons").doc().set(this.lesson)
        .then(function() {
            console.log("Document successfully written!");
        })
        .catch(function(error) {
            console.error("Error writing document: ", error);
        });
        this.loading = false;

        this.$router.back();
      } else {
        alert(
          "Та хичээлийнхээ нэр, анги/группээр орох , ангилал болон багш ангиудаа оруулна уу"
        );
      }
    },
    addClassToGroup(group, batch, lessonRef) {
      if (group && group.data() && group.data().groups) {
        for (const data of group.data().groups) {
          batch.update(lessonRef, {
            groups: fb.firestore.FieldValue.arrayUnion(data),
          });
        }
      }
      if (group && group.data() && group.data().programs) {
        for (const data of group.data().programs) {
          batch.update(lessonRef, {
            programs: fb.firestore.FieldValue.arrayUnion(data),
          });
        }
      }
      if (group && group.data() && group.data().programIds) {
        for (const data of group.data().programIds) {
          batch.update(lessonRef, {
            programIds: fb.firestore.FieldValue.arrayUnion(data),
          });
        }
      }
      if (group && group.data() && group.data().departments) {
        for (const data of group.data().departments) {
          batch.update(lessonRef, {
            departments: fb.firestore.FieldValue.arrayUnion(data),
          });
        }
      }
      if (group && group.data() && group.data().classNos) {
        for (const data of group.data().classNos) {
          batch.update(lessonRef, {
            classNos: fb.firestore.FieldValue.arrayUnion(data),
          });
        }
      }
    },

    setLesson() {
      this.lesson = {
        name: "",
        description: "",
        included: [],
        lectureCode: "",
        profession: "",
        requirements: [],
        results: [],
        whatlearned: [],
        skills: [],
        handlaga: [],
        semester: null,
        credit: null,
        types: [],
        price: 0,
      };
    },

    remove(index, array) {
      if (array != null && array.length > 0) array.splice(index, 1);
    },

    addType(type) {
      if (this.lesson.types == null || this.lesson.types == undefined)
        this.lesson.types = [];
      if (!this.lesson.types.includes(type)) this.lesson.types.push(type);
      else this.lesson.types.splice(this.lesson.types.indexOf(type), 1);
    },

    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    async _getCategories() {
      this.teacherDoc=await this.userProfile['customer'].get();
      fb.db
        .collection("schools/" + this.schoolId + "/categories")
        .orderBy("index")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((paymentData) => {
            let object = paymentData.data();
            object.ref = paymentData.ref;
            object.id = paymentData.id;
            if (
              this.categoryId &&
              this.categoryId != "" &&
              this.categoryId != "new" &&
              this.categoryId == object.id
            ) {
              this.lesson.category = paymentData.ref;
            }
            this.categories.push(object);
          });
        });

      fb.db
        .collection("schools/" + this.schoolId + "/sectors")
        .orderBy("name")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((paymentData) => {
            let object = paymentData.data();
            object.ref = paymentData.ref;
            object.id = paymentData.id;
            this.sectors.push(object);
          });
        });

      fb.db
        .collection("schools/" + this.schoolId + "/departments")
        .where("startYear", "==", this.school.currentYear)
        .orderBy("index")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((paymentData) => {
            let object = paymentData.data();
            object.ref = paymentData.ref;
            object.id = paymentData.id;
            this.departments.push(object);
          });
        });
    },
    _getPros(school) {
      if (school && school.ref) {
        school.ref
          .collection("programs")
          .orderBy("name")
          .get()
          .then((docs) => {
            this.programs = [];
            docs.docs.forEach((doc) => {
              let object = doc.data();
              object.id = doc.id;
              object.ref = doc.ref;
              this.programs.push(object);
            });
          });
      }
    },
    _addClass() {
      // this.school=null;
      this.selectedTeacher = null;
      this.department = null;
      this.selectedPrograms = [];
      $("#exampleModal").modal("toggle");
    },
    _addGroup() {
      this.selectedTeacher = null;
      this.department = null;
      this.selectedPrograms = [];
      this.selectedGroups = [];
      $("#groupModal").modal("toggle");
    },
    toggleDepartmentFilter(department, list) {
      if (this.isInDepartmentFilter(department, list) == true) {
        this.removeFromDepartmentFilter(department, list);
      } else {
        list.push(department);
      }
    },
    isInDepartmentFilter(department, list) {
      var exists = false;
      for (const current of list) {
        if (current && current.id && current.id == department.id) {
          exists = true;
          break;
        }
      }
      return exists;
    },
    removeFromDepartmentFilter(department, list) {
      var exists = false;
      var index = 0;
      var i = 0;
      for (const current of list) {
        if (current && current.id && current.id == department.id) {
          exists = true;
          index = i;
          break;
        }
        i++;
      }
      if (exists && exists == true) {
        list.splice(index, 1);
      }
    },
    _addProgram() {
      if (
        this.selectedTeacher &&
        this.department &&
        this.selectedPrograms &&
        this.selectedPrograms.length > 0
      ) {
        var object = {
          teacher: this.selectedTeacher,
          department: this.department,
          programs: this.selectedPrograms,
          isGroup: false,
        };
        this.groupList.push(object);
      } else {
        alert("Та хичээл заах багш болон ангиудын мэдээллээ бүрэн оруулна уу.");
      }
    },
    _addObjectToGroup() {
      if (this.selectedTeacher && this.selectedGroups) {
        var object = {
          teacher: this.selectedTeacher,
          programs: this.selectedGroups ? this.selectedGroups : [],
          isGroup: true,
        };
        this.groupList.push(object);
      } else {
        alert("Та хичээл заах багш болон ангиудын мэдээллээ бүрэн оруулна уу.");
      }
    },
  },

  created() {
    if (this.schoolId) {
      fb.db.collection('schools').doc(this.schoolId).get().then((schoolDoc)=>{
        if(schoolDoc.exists){
          this.school = schoolDoc.data()
          this.school.id = schoolDoc.id
          this.school.ref = schoolDoc.ref
        }
      }
      )
        this._getCategories();
    }
  },
  props: {
    schoolId: {
      required: true,
    },
    setTeacher: {
      required: false,
    },
    categoryId: {
      required: false,
    },
  },
};
</script>

